import type { FormatIntlLang } from '../types';

export const locales: Record<FormatIntlLang, string> = {
  en: 'en-US',
  es: 'es-ES',
};
